/* eslint-disable */
// src/utils/navigateEditVisitTransactionHelper.js

import { normalizeVisitDetailLocal } from "layouts/visitMachine/collectionWorkflow";

export function navigateEditVisitTransactionHelper(
  navigate,
  visitId,
  local,
  profitPercentages,
  localMachineDetails,
  machines,
  lastCredits,
  displayDate,
  visitDateTime,
  lastLocalVisitBeforeId = null,
  lastLocalVisitBeforeDate = null,
  returnTo = null
) {
  if (!visitId || !local?.Id) return;
  const canonicalLocal = normalizeVisitDetailLocal({
    local,
    person: local?.Person,
  });

  navigate(`/local/${canonicalLocal.Id}/visitMachine/${visitId}/editar`, {
    state: {
      local: canonicalLocal,
      visitWithCollectionId: visitId,
      localMachineDetails,
      profitPercentages,
      calculatedVisitMachines: machines,
      prevCredits: lastCredits,
      currentDate: displayDate,
      visitDateTime,
      LastLocalVisitBeforeId: lastLocalVisitBeforeId,
      LastLocalVisitBeforeDate: lastLocalVisitBeforeDate,
      returnTo,
    },
  });
}
